<template>
  <div>
    <div
      v-if="cardType.shapeStyles"
      class=""
      :class="cardType.shapeClasses[state]"
      :style="cardType.shapeStyles[state]"
    ></div>
    <oh-v-icon
      class="mt-1"
      :color="cardType.colors ? cardType.colors[state] : cardType.color"
      :size="size"
      :scale="scale"
      :class="cardType.color"
      :style="cardType.iconStyles ? cardType.iconStyles[state] : cardType.style"
      :name="cardType.icon"
    >
    </oh-v-icon>

    <!-- <v-badge v-else avatar overlap color="transparent" offset-y="70%">
      <template v-slot:badge>
        <v-icon class="" :color="cardType.color" :small="!size" :x-small="size == 'small'">
          {{ cardType.icon2 }}
        </v-icon>
      </template>

      <v-icon
        class=""
        :color="cardType.color"
        :size="size"
        :style="cardType.rotate ? `transform: rotate(${cardType.rotate})` : null"
      >
        {{ cardType.icon }}
      </v-icon>
    </v-badge> -->
  </div>
</template>

<script>
import cardTypes from './cardTypes';
export default {
  props: {
    pageType: { default: '' },
    size: { default: undefined },
    small: { default: false },
    xsmall: { default: false },
    medium: { Default: false },
    state: { default: 0 }
  },
  computed: {
    cardType() {
      const type = this.pageType >= 0 ? this.pageType : 1;
      let card = cardTypes.find(t => t.value == type);
      if (!card) {
        card = cardTypes.find(t => t.value == 0);
      }
      return card;
    },
    scale() {
      if (this.xsmall) {
        return 0.7;
      } else if (this.small) {
        return 0.9;
      } else if (this.lg) {
        return 1.1;
      } else {
        return 1;
      }
    }
  }
};
</script>

<style></style>
